/**
 * Mejora progresiva de los chips de color de la tarjeta (card-color-swatches +
 * card-color-gallery). El cambio de foto al hacer clic ya funciona sólo con CSS
 * (radios + `:checked`); este script únicamente:
 *   1. Mueve el anillo "activo" al chip del color elegido.
 *   2. Sincroniza el enlace principal de la tarjeta con la variante del color
 *      (para que un clic en cualquier parte de la tarjeta lleve a ese color).
 *
 * Es un único listener delegado en el documento: no añade nada por tarjeta.
 */
document.addEventListener('change', (event) => {
  const radio = event.target;
  if (!(radio instanceof HTMLInputElement) || !radio.classList.contains('cpair__radio')) return;
  if (!radio.checked) return;

  const card = radio.closest('product-card, .product-card');
  if (!card) return;

  // 1) Mover el anillo activo al chip correspondiente.
  const chips = card.querySelectorAll('.card-color-swatches__chip');
  chips.forEach((chip) => chip.classList.remove('card-color-swatches__chip--active'));
  const activeChip = card.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
  activeChip?.classList.add('card-color-swatches__chip--active');

  // 2) Sincronizar con la URL del color: el enlace principal de la tarjeta,
  //    el del título y cualquier otro enlace marcado (foto). Así un clic en
  //    cualquier parte de la tarjeta lleva al color elegido.
  const url = radio.dataset.url;
  if (url) {
    const links = card.querySelectorAll('a.product-card__link, a[ref="productTitleLink"]');
    links.forEach((link) => {
      if (link instanceof HTMLAnchorElement) link.href = url;
    });
  }
});

/* ─────────────────────────────────────────────────────────────────────────────
 * La foto del HOVER se descarga solo cuando hace falta.
 *
 * `card-color-gallery.liquid` la emite SIN `src` (la URL vive en `data-src`).
 * Aquí se carga cuando el puntero se acerca a la tarjeta, o cuando algo dentro
 * de ella recibe el foco por teclado.
 *
 * Por qué: `loading="lazy"` no bastaba. Solo espera a que la tarjeta entre en
 * pantalla, y a partir de ahí baja la foto SIEMPRE — también en el celular,
 * donde no hay hover y esa foto no se ve nunca. Medido en `/collections/lo-nuevo`
 * con 4G: 61 de las 98 imágenes descargadas (2.235 KB) no llegaban a verse.
 * ───────────────────────────────────────────────────────────────────────────── */
(() => {
  const hayRaton = window.matchMedia('(hover: hover)').matches;

  const cargarDetalle = (card) => {
    if (!card || card.dataset.latDetalleCargado) return;
    card.dataset.latDetalleCargado = '1';
    for (const img of card.querySelectorAll('.cpair__img--detail[data-src]')) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  };

  // `pointerover` sí burbujea (a diferencia de `pointerenter`), así que basta un
  // único listener para toda la página, sin recorrer las tarjetas.
  if (hayRaton) {
    document.addEventListener(
      'pointerover',
      (event) => {
        const destino = event.target;
        if (!(destino instanceof Element)) return;
        cargarDetalle(destino.closest('product-card, .product-card'));
      },
      { passive: true }
    );
  }

  // Con teclado no hay puntero: el foco hace de aviso.
  document.addEventListener('focusin', (event) => {
    const destino = event.target;
    if (!(destino instanceof Element)) return;
    cargarDetalle(destino.closest('product-card, .product-card'));
  });
})();
